import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./booking-carousel.css";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

const BookingCarousel = () => {
  const scrollRef = useRef(null);

  const scrollOne = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const card = container.querySelector(".carousel-card");
    if (!card) return;

    const cardWidth = card.offsetWidth + 20;

    container.scrollBy({
      left: direction === "right" ? cardWidth : -cardWidth,
      behavior: "smooth",
    });
  };

  const { t } = useTranslation();

  return (
    <div className="carousel-wrapper">
      {/* Left Button */}
      <button
        className="nav-btn nav-left"
        onClick={() => scrollOne("left")}
      >
        ‹
      </button>

      {/* Right Button */}
      <button
        className="nav-btn nav-right"
        onClick={() => scrollOne("right")}
      >
        ›
      </button>

      {/* Scroll Container */}
      <div className="carousel-container" ref={scrollRef}>

        {/* 1 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=1" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/chamundeswari-devi.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p1")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
        </a>

        {/* 2 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=2" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/ganapathy.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p2")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
        </a>

        {/* 3 */}
        {/* <a href="#" className="carousel-card"> */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=3" className="carousel-card">
        <div className="carousel-card-">
          <img src="./images/diety/ayyappan.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p3")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
    </a>
        {/* 4 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=4" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/murukan.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p4")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
    </a>
        {/* 5 */}
        {/* <a href="#" className="carousel-card"> */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=5" className="carousel-card">
        <div className="carousel-card-">
          <img src="./images/diety/siva.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p5")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
    </a>
        {/* 6 */}
        {/* <a href="#" className="carousel-card"> */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=6" className="carousel-card">
        <div className="carousel-card-">
          <img src="./images/diety/hanuman.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p6")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
    </a>
        {/* 7 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=7" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/KARINGALI.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p7")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 8 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=8" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/nagarajavu.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p8")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 9 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=9" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/marutha.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p9")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 10 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=10" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/madan.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p10")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 11 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=11" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/muni.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p11")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 12 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=12" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/RAKSHASS.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p12")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 13 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=13" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/yogi.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p13")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 14 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=14" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/MANTRA.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p14")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 15 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=15" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/sundara.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p15")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
        {/* 16 */}
        <a href="https://booking.pattarathtemple.org/Default.aspx?i=16" className="carousel-card">
        {/* <a href="#" className="carousel-card"> */}
        <div className="carousel-card-">
          <img src="./images/diety/RAKTHA.png" alt="Booking" className="card-image" />
          <h6 className="card-title">{t("p16")}</h6>
          <div className="card-action"><span style={{color:'maroon'}}>Book Now</span></div>
        </div>
</a>
       

      </div>
    </div>
  );
};

export default BookingCarousel;
    